/**
 * Giờ Việt Nam là giờ nghiệp vụ của hệ — anh Toàn chốt 20/09/2026: "dùng giờ Việt Nam, không dùng giờ UTC".
 *
 * Worker chạy theo UTC, nên `new Date(ms).toISOString().slice(0, 10)` là ngày UTC: từ 00:00 tới 07:00 sáng giờ Việt Nam nó
 * còn là hôm qua — chứng từ lập lúc 00:14 ngày 20/09 mang số 20260919, "hôm nay" của MRP lùi một ngày, mặc định ngày trên biểu mẫu
 * là hôm qua. Mọi "ngày" nghiệp vụ lấy từ MỘT MỐC THỜI GIAN (số chứng từ theo ngày / năm, "hôm nay", tháng của một mốc) phải qua
 * đây. Việt Nam không đổi giờ theo mùa nên cộng cố định 7 giờ là đúng quanh năm.
 *
 * Chuỗi 'YYYY-MM-DD' đã là ngày (không có giờ) thì KHÔNG qua đây — cộng trừ ngày trên chuỗi đó vẫn làm theo UTC cho khỏi lệch.
 * Mốc lưu lúc 00:00 UTC của một ngày (ngày chọn trên biểu mẫu) qua đây vẫn ra đúng ngày đó (07:00 cùng ngày giờ Việt Nam).
 */
export const VN_UTC_OFFSET_MS = 7 * 3_600_000;
export const VN_TIME_ZONE = "Asia/Ho_Chi_Minh";

/** Ngày Việt Nam 'YYYY-MM-DD' của một mốc thời gian (mặc định: bây giờ). */
export function vnDate(ms: number = Date.now()): string {
  return new Date(ms + VN_UTC_OFFSET_MS).toISOString().slice(0, 10);
}

/** 'YYYYMMDD' — phần ngày trong số chứng từ (SCL-20260920-0001) và khoá bộ đếm theo ngày. */
export function vnDayKey(ms: number = Date.now()): string {
  return vnDate(ms).replaceAll("-", "");
}

/** Năm Việt Nam — số chứng từ theo năm (PO-2026-001). */
export function vnYear(ms: number = Date.now()): number {
  return new Date(ms + VN_UTC_OFFSET_MS).getUTCFullYear();
}

/** Tháng Việt Nam 'YYYY-MM'. */
export function vnMonth(ms: number = Date.now()): string {
  return vnDate(ms).slice(0, 7);
}

/** Mốc 00:00 giờ Việt Nam, ngày 1 của tháng chứa `ms` (epoch ms), lùi `monthsBack` tháng. */
export function vnStartOfMonth(ms: number = Date.now(), monthsBack = 0): number {
  const d = new Date(ms + VN_UTC_OFFSET_MS);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - monthsBack, 1) - VN_UTC_OFFSET_MS;
}

/** Ngày giờ Việt Nam 'YYYY-MM-DD HH:mm:ss' — cho người đọc (tệp xuất, "tính lúc"). */
export function vnDateTime(ms: number = Date.now()): string {
  return new Date(ms + VN_UTC_OFFSET_MS).toISOString().slice(0, 19).replace("T", " ");
}

/** Mốc thời gian dạng ISO 8601 theo giờ Việt Nam, có múi '+07:00' — đọc máy được như `toISOString()` nhưng không phải giờ UTC. */
export function vnIso(ms: number = Date.now()): string {
  return new Date(ms + VN_UTC_OFFSET_MS).toISOString().slice(0, 19) + "+07:00";
}
